import type { PriceVenue } from '@api/api/price-schema';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useQuery } from '@tanstack/react-query';
import { getPreliminaryPrice } from '@terminal/services/price/price-service';

const QUERY_KEY_PRELIMINARY_PRICE = 'QUERY_KEY_PRELIMINARY_PRICE';

export const usePreliminaryPrice = (ticker: string, venue?: PriceVenue) => {
  return useQuery({
    queryKey: [
      QUERY_KEY_PRELIMINARY_PRICE,
      ticker,
      venue?.exchange,
      venue?.country,
    ],
    queryFn: ({ signal }) => getPreliminaryPrice(ticker, venue, signal),
    staleTime: getTimeTillEndOfDayMs(),
    enabled: !!ticker,
  });
};
